import * as React from 'react';

import FolderPersonal32 from './FolderPersonal32';

export const folderPersonal32 = () => <FolderPersonal32 />;

export default {
    title: 'Icon|Content|FolderPersonal32',
    component: FolderPersonal32,
    parameters: {
        notes: "`import FolderPersonal32 from 'box-ui-elements/es/icon/content/FolderPersonal32';`",
    },
};
